export default __webpack_public_path__ + "static/media/Ei-lock.svg.33b6c30d.png";